import { AppContext } from "@/contexts/AppContext"
import { useContext } from "react"

function useAppContext() {
  const { isMobile, setIsMobile, contextMenu, setContextMenu } = useContext(AppContext)
  return { isMobile, setIsMobile, contextMenu, setContextMenu }
}

export default useAppContext
